<template>
  <v-container>
    <RelationChosenWidgetInput
      :value="listItem.data.where.id"
      :entity="'places'"
      @drag-change="change"
      @input="mixChangeListItemHandler({ id: $event }, 'where')"
    />
  </v-container>
</template>

<script>
import dynamicListItemMix from '@/mixins/dynamic-list/dynamicListItem.mix.js'
import RelationChosenWidgetInput from '@/components/dynamic-list-items/widgets/feeds/inputs/RelationChosenWidgetInput'
export default {
  name: 'PlacesChosenWidget',
  mixins: [dynamicListItemMix],
  components: {
    RelationChosenWidgetInput
  },
  methods: {
    change ({ value, dragged }) {
      if (value.removed) {
        // insert
        this.listItem.data.where.id.splice(
          dragged.to + dragged.newIndex, 0, this.listItem.data.where.id[dragged.from]
        )
        // delete
        if (dragged.from < dragged.to) {
          this.listItem.data.where.id.splice(dragged.from, 1)
        } else {
          this.listItem.data.where.id.splice(dragged.from + 1, 1)
        }
      }
    }
  }
}
</script>
